'use client'
import React, { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import Gallery from '@components/Gallery'
import Video from '@components/Video'
import VideoGallery from '@components/VideoGallery'
import { IoMdPhotos, IoMdVideocam } from 'react-icons/io'
import { Navigation } from 'swiper/modules';

// Import Swiper styles
import "swiper/css";
import 'swiper/css/navigation';

const PropertyGallery = ({ status = undefined, gallery, videoUrl, dictionary }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);

    const openPopup = (index) => {
        if (gallery && gallery.length > 0) {
            setActiveSlide(index)
            setPopupOpen(true);
            setVideoPopupOpen(false);
        }
    };

    const openVideoPopup = () => {
        setVideoPopupOpen(true);
        setPopupOpen(false);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    const closeVideoPopup = () => {
        setVideoPopupOpen(false);
    };

    return (
        <>
            {videoUrl ? (
                <div className='hidden sm:flex w-full flex-row'>
                    <div className='w-1/2 py-1 pr-1'>
                        <div className='relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-maincolor hover:shadow-md hover:shadow-third/30'>
                            <div className='w-full h-full relative flex justify-center items-center overflow-hidden'>
                                <Video className='z-20' url={videoUrl}   />
                            </div>
                        </div>
                    </div>
                    <div className='w-1/2 flex flex-wrap'>
                        {gallery.map((value, index) => {
                            if (index >= 0 && index <= 3) {
                                // Map only elements at indices 1 to 3 (inclusive)
                                return (
                                    <div className='w-1/2 p-1' key={index}>
                                        <div className={`relative w-full aspect-[4/3] rounded-xl overflow-hidden hover:shadow-md hover:shadow-third/30 duration-150`}>
                                            <Image
                                                onClick={() => openPopup(index)}
                                                // placeholder="blur"
                                                // blurDataURL={property.blur}
                                                // className='object-fit'
                                                className='object-cover cursor-pointer hover:shadow-xl'
                                                src={gallery[index]}
                                                // width={imageWidth}
                                                // height={imageHeight}
                                                fill={true}
                                                // alt={property.slug}
                                            />
                                        {index == 4 && (
                                            <div 
                                                className='group absolute overflow-hidden rounded-xl z-40 top-0 left-0 bottom-0 right-0 flex justify-center items-center bg-black bg-opacity-30 hover:bg-opacity-0 duration-150 cursor-pointer'
                                                onClick={() => openPopup(0)}
                                            >
                                                <div className='z-50 flex flex-row items-center text-xl text-maincolor border-[1px] border-maincolor bg-light px-2 py-1 m-2 rounded-md font-semibold'>
                                                    <IoMdPhotos
                                                        className="mr-1"
                                                    />
                                                    {gallery.length} {dictionary.property.photos}
                                                </div>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                )
                            }
                            })}
                    </div>
                </div>
            ):(
                <div className='hidden sm:flex w-full flex-row'>
                    <div className='w-1/2 py-1 pr-1'>
                        <div className='relative w-full aspect-[4/3] rounded-xl overflow-hidden hover:shadow-md hover:shadow-third/30 duration-150'>
                            <Image
                                onClick={() => openPopup(0)}
                                // placeholder="blur"
                                // blurDataURL={property.blur}
                                // className='object-fit'
                                className='object-cover cursor-pointer'
                                src={gallery[0] !== undefined ? gallery[0] : '/images/test.jpg'}
                                // width={imageWidth}
                                // height={imageHeight}
                                fill={true}
                                // alt={property.slug}
                            />
                            {status == 'sold' && (
                                <div className="z-20 flex items-center justify-center absolute top-0 left-0 bottom-0 right-0 bg-maincolor/50">
                                    <div className="bg-red-600 rounded-full p-2">
                                        <span className="text-3xl text-light">{dictionary.property.hasBeenSold}</span>
                                    </div>
                                </div>
                            )}
                            {status == 'rented' && (
                                <div className="z-20 flex items-center justify-center absolute top-0 left-0 bottom-0 right-0 bg-maincolor/50">
                                    <div className="bg-red-600 rounded-full p-2">
                                        <span className="text-3xl text-light">{dictionary.property.hasBeenRented}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='w-1/2 flex flex-wrap'>
                        {gallery.map((value, index) => {
                            if (index >= 1 && index <= 4) {
                                // Map only elements at indices 1 to 3 (inclusive)
                                return (
                                    <div className='w-1/2 p-1' key={index}>
                                        <div className={`relative w-full aspect-[4/3] rounded-xl overflow-hidden hover:shadow-md hover:shadow-third/30 duration-150 ${index == 4 ? 'group' : ''}`}>
                                            <Image
                                                onClick={() => openPopup(index)}
                                                // placeholder="blur"
                                                // blurDataURL={property.blur}
                                                // className='object-fit'
                                                className='object-cover cursor-pointer hover:shadow-xl'
                                                src={gallery[index]}
                                                // width={imageWidth}
                                                // height={imageHeight}
                                                fill={true}
                                                // alt={property.slug}
                                            />
                                            {(status == 'sold' || status == 'rented') && (
                                                <div className="z-20 flex items-center justify-center absolute top-0 left-0 bottom-0 right-0 bg-maincolor/50"></div>
                                            )}
                                        {index == 4 && (
                                            <div 
                                                className='group absolute overflow-hidden rounded-b-md z-40 left-0 bottom-0 right-0 flex justify-end items-end bg-gradient-to-t from-third/70 to-third/0 hover:bg-gradient-to-t group-hover:from-third/80 group-hover:to-third/0 group-hover:bg-opacity-0 duration-300 cursor-pointer'
                                                onClick={() => openPopup(0)}
                                            >
                                                <div className='z-50 flex flex-row items-center text-md text-maincolor border-[1px] border-third hover:border-maincolor bg-light px-2 py-1 m-2 rounded-md font-semibold'>
                                                    <IoMdPhotos
                                                        className="mr-1"
                                                    />
                                                    {gallery.length} {dictionary.property.photos}
                                                </div>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                )
                            }
                            })}
                    </div>
                </div>
            )}
            {videoUrl ? (
                <div className='block sm:hidden'>
                    <Swiper
                        className="mySwiper"
                    >
                        {videoUrl && (
                            <SwiperSlide key={'video'} className="relative w-full">
                                <div className='w-full max-h-[270px] relative overflow-hidden  video-slide'>
                                    <Video className='z-20' url={videoUrl} height={"270"} width={"420"} />
                                </div>
                            </SwiperSlide>
                        )

                        }
                        {gallery && gallery.map((image, index) => (
                            <SwiperSlide key={index} className="relative">
                                <div className='w-full max-h-[270px] relative overflow-hidden'>
                                    <Image
                                        onClick={openPopup}
                                        src={image}
                                        // src={`https://rstbase.com/images/properties/${propertyId}/${image}`}
                                        alt="image"
                                        width={1000}
                                        height={667}
                                        priority={index == 0 ? true : false}
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAYAAACqNX6+AAAAXUlEQVR42u3RMQEAAAgDoJnc6FrB0wMqUMl0eKOECEGIEIQIQYgQhAgRIgQhQhAiBCFCECIEIQgRghAhCBGCECEIQYgQhAhBiBCECEEIQoQgRAhChCBECEIQIoSrBfgKSs//8LAxAAAAAElFTkSuQmCC"
                                    />
                                </div>

                                <div className="absolute z-10 bottom-2 right-2 flex flex-row items-center bg-maincolortrans rounded-md text-light p-1">
                                    <span>{index + 1}/{gallery.length}</span>
                                    <IoMdPhotos
                                        className="ml-1"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            ):(
                <div className='block sm:hidden'>
                    <Swiper
                        className="mySwiper"
                    >
                        {videoUrl && (
                            <SwiperSlide key={'video'} className="relative w-full">
                                <div className='w-full max-h-[270px] relative overflow-hidden video-slide'>
                                    <Video className='z-20' url={videoUrl} height={"270"} width={"420"} />
                                </div>
                            </SwiperSlide>
                        )

                        }
                        {gallery && gallery.map((image, index) => (
                            <SwiperSlide key={index} className="relative">
                                <div className='relative w-full aspect-square overflow-hidden'>
                                    <Image
                                        onClick={openPopup}
                                        src={image}
                                        // src={`https://rstbase.com/images/properties/${propertyId}/${image}`}
                                        alt="image"
                                        width={1000}
                                        height={667}
                                        priority={index == 0 ? true : false}
                                        placeholder="blur"
                                        className="object-cover h-full w-full"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAYAAACqNX6+AAAAXUlEQVR42u3RMQEAAAgDoJnc6FrB0wMqUMl0eKOECEGIEIQIQYgQhAgRIgQhQhAiBCFCECIEIQgRghAhCBGCECEIQYgQhAhBiBCECEEIQoQgRAhChCBECEIQIoSrBfgKSs//8LAxAAAAAElFTkSuQmCC"
                                    />
                                    {status == 'sold' && (
                                        <div className="z-20 flex items-center justify-center absolute top-0 left-0 bottom-0 right-0 bg-maincolor/50">
                                            <div className="bg-red-600 rounded-full p-2">
                                                <span className="text-xl text-light">{dictionary.property.hasBeenSold}</span>
                                            </div>
                                        </div>
                                    )}
                                    {status == 'rented' && (
                                        <div className="z-20 flex items-center justify-center absolute top-0 left-0 bottom-0 right-0 bg-maincolor/50">
                                            <div className="bg-red-600 rounded-full p-2">
                                                <span className="text-xl text-light">{dictionary.property.hasBeenRented}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="absolute z-10 bottom-2 right-2 flex flex-row items-center bg-maincolor/70 rounded-full text-third py-1 px-2">
                                    <span>{index + 1}/{gallery.length}</span>
                                    <IoMdPhotos
                                        className="ml-1"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
            <Gallery isOpen={isPopupOpen} onClose={closePopup} gallery={gallery} videoUrl={videoUrl} initialSlide={activeSlide} />
            <VideoGallery isVideoOpen={isVideoPopupOpen} onVideoClose={closeVideoPopup} videoUrl={videoUrl} />
        </>
    )
}

export default PropertyGallery